<div class="section-divider-wrapper" *transloco="let t">
  <span class="section-divider-wrapper__line"></span>
  <span class="section-divider-wrapper__text"><p class="regular">{{ t('app.common.or') }}</p></span>
  <span class="section-divider-wrapper__line"></span>
</div>
